import Controller from '@ember/controller';
import { service } from '@ember/service';
import CampaignService from 'donor-elf-web/services/campaign-service';
import { action } from '@ember/object';
import AddSomethingModal from 'donor-elf-web/services/add-something-modal';

export default class CampaignsIndexController extends Controller {
  @service declare campaignService: CampaignService;
  @service declare addSomethingModal: AddSomethingModal;

  get campaigns() {
    return this.campaignService.sortedCampaigns;
  }

  @action
  handleAddCampaign() {
    this.addSomethingModal.open({ type: 'campaign' });
  }
}
